import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {BillingParty} from '../../../graphql/billing_party.datatypes';
import {gqlBillingParty} from '../../BillingParty/getBillingParty.api';


export interface AuthoriseGroupMembersInBillingPartyInput {
    id: number
    authorise: boolean
}

interface AuthoriseGroupMembersInBillingPartyData {
    __typename?: string,
    authoriseGroupMembersInBillingParty: BillingParty
}

export const AUTHORISE_GROUP_MEMBER_MUTATION = gql`
    mutation authoriseGroupMembersInBillingParty($id: Int!, $authorise: Boolean!) {
        authoriseGroupMembersInBillingParty(id: $id, authorise: $authorise) {
            ${gqlBillingParty}
        }
    }
`;

export const authoriseGroupMembersInBillingParty = () => useMutation<AuthoriseGroupMembersInBillingPartyData, AuthoriseGroupMembersInBillingPartyInput>(
    AUTHORISE_GROUP_MEMBER_MUTATION,
    {
        update: updateCacheByType('BillingParty'),
    }
);

export default authoriseGroupMembersInBillingParty;